import { createElement, forwardRef } from 'react';
import { circle } from '../patterns/circle.js';
import { splitProps } from '../helpers.js';
import { styled } from './factory.js';

export const Circle = /* @__PURE__ */ forwardRef(function Circle(props, ref) {
  const [patternProps, restProps] = splitProps(props, circle.propKeys)
  const styleProps = circle.raw(patternProps)
  const mergedProps = { ref, ...styleProps, ...restProps }
  return createElement(styled["div"], mergedProps)
})